function setupInteractions() {
  $(".right-img, .left-img").off("mouseenter");

  const isDesktop = window.innerWidth >= 1200;

  if (isDesktop) {
    $(".right-img, .left-img").on("mouseenter", function () {
      const $parent = $(this).closest(".right-grid-col, .left-grid-col");
      if (!$parent.length) return;

      $(".right-grid-col, .left-grid-col").removeClass("active");
      $parent.addClass("active");

      const tooltip = $parent.find(".tooltiptext");
      const title = $parent.find("h5");

      if (tooltip.length && title.length) {
        $(".show-popup-content p").html(tooltip.html());
        $(".show-popup-content h3").html(title.html());
      }
    });
  } else {
    $(".right-grid-col, .left-grid-col").on("click", function () {
      $(".right-grid-col, .left-grid-col").removeClass("active");
      $(this).addClass("active");

      const tooltip = $(this).find(".tooltiptext");
      const title = $(this).find("h5");

      if (tooltip.length && title.length) {
        $(".show-popup-content p").html(tooltip.html());
        $(".show-popup-content h3").html(title.html());
      }
    });
  }
}

$(document).ready(function () {
  $(document).on("click", '.hover-content.tooltiptext a[href="#popup"]', function (e) {
    e.preventDefault();
    const get_class = $(this).parents(".tooltiptext").data("index");
    $("." + get_class).css("opacity", 1).show();
  });

  $(".hover_bkgr_fricc").click(function (e) {
    if (!$(e.target).closest(".custom-size-img").length) {
      $(".hover_bkgr_fricc").hide();
    }
  });

  $(".popupCloseButton").click(function () {
    $(".hover_bkgr_fricc").hide();
  });

  if (window.innerWidth < 1200) {
    $(".left-grid-col.left-g-1.tooltip").addClass("active");
  } else {
    $(".right-grid-col.right-g-7.tooltip").addClass("active");
  }

  setupInteractions();

  $(window).on("resize", function () {
    setupInteractions();
  });
});
